// extracted by mini-css-extract-plugin
module.exports = {"banner":"G_cz","icon":"G_bj","title":"G_bH","text":"G_cB","button":"G_cp"};